module.exports = __webpack_public_path__ + "img/bgc21.7622d684.png";